import React from 'react';
import { Icon } from '@iconify/react';
import { HighlightedTextIcon } from 'components/molecules';
import { AboutSectionContentProps } from 'components/organisms/About/types';
import reactIcon from '@iconify/icons-logos/react';
import tailwindcssIcon from '@iconify/icons-logos/tailwindcss-icon';

const Text = () => (
    <>
        Ich entwerfe hochmoderne Full-Stack-Weblösungen mit <HighlightedTextIcon
            as="a"
            href="https://reactjs.org"
            className="mx-2"
            icon={<Icon icon={reactIcon} />}
        >
            <span className="font-bold text-gray-800">React</span>
        </HighlightedTextIcon>
        {', '} <HighlightedTextIcon as="a" href="https://www.typescriptlang.org/" className="mx-2" icon={<img src="/img/typescript.svg" alt="TypeScript" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">TypeScript</span>
        </HighlightedTextIcon>, und <HighlightedTextIcon as="a" href="https://supabase.com/" className="mx-2" icon={<img src="/img/supabase.svg" alt="Supabase" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">Supabase</span>
        </HighlightedTextIcon>. Meine Spezialität ist die Entwicklung reaktionsschneller Benutzeroberflächen und solider Backends für moderne Webanwendungen. Ich baue gerne produktionsreife Web-Apps mit
        <HighlightedTextIcon
            as="a"
            href="https://reactjs.org"
            className="mx-2"
            icon={<Icon icon={reactIcon} />}
        >
            <span className="font-bold text-gray-800">React</span>
        </HighlightedTextIcon>
        {' '}und
        <HighlightedTextIcon
            as="a"
            href="https://tailwindcss.com"
            className="mx-2"
            icon={<Icon icon={tailwindcssIcon} />}
        >
            <span className="font-bold text-gray-800">TailwindCSS</span>
        </HighlightedTextIcon>
        {' '}und
        <HighlightedTextIcon
            as="a"
            href="https://ui.shadcn.com/"
            className="mx-2"
            icon={<img src="/img/shadcn.svg" alt="ShadCN" className="w-5 h-5" />}
        >
            <span className="font-bold text-gray-800">ShadCN/UI</span>
        </HighlightedTextIcon>

        {'. '}Ich habe auch Erfahrung in der Erstellung von Web-Apps mit
        <HighlightedTextIcon as="a" href="https://nextjs.org/" className="mx-2" icon={<img src="/img/nextjs.svg" alt="Next.js" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">Next.js</span>
        </HighlightedTextIcon>. Ich arbeite seit etwa <span className="font-bold text-gray-800">2 Jahren</span> mit diesen Tools und bin zuversichtlich, Apps damit zu erstellen. Ich habe ein Praktikum als Webentwickler bei

        <HighlightedTextIcon as="a" href="https://weabers.com/" className="mx-2" icon={<img src="/img/weabers.avif" alt="Weabers" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">Weabers</span>
        </HighlightedTextIcon>{'. '} Ich bin auch ein <HighlightedTextIcon as='a' href="https://www.sports.com" className="mx-2" icon={<img src="/img/sports.svg" alt="sports" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">Sportbegeisterter</span>
        </HighlightedTextIcon> und ein <HighlightedTextIcon
            as='a'
            href="https://robocopplays.netlify.app/"
            className="mx-2"
            icon={<img src="/img/gamer.svg" alt="gamer" className="w-5 h-5" />}
        >
            <span className="font-bold text-gray-800">Gamer</span>
        </HighlightedTextIcon>.
    </>
);

const about: AboutSectionContentProps = {
    text: <Text />,
};

export default about;
